import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  Layout,
  Table,
  Button,
  Dropdown,
  Tag,
  Typography,
  Tooltip,
  Row,
  Col,
  Space,
  Modal,
  notification,
} from "antd";
import {
  PlusOutlined,
  FileDoneOutlined,
  FileExcelOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import {
  getAllSolicitation,
  approveSolicitations,
  getValidationSolicitation,
  getBankSplit,
  getPixQRCode,
  cancelSolicitation,
  approveSolicitation,
  getPaySchedule,
} from "services/solicitation-service";
import { getInvoiceTransactions } from "services/company-service";
import { useShareholderStatus } from "hooks/useShareholderStatus";
import {
  Header,
  FormatDate,
  FormatMoney,
  CardCompanyBalance,
  TableSearch,
  LoadingText,
  DatePicker,
} from "components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { consolidatedReport, downloadBankSlip } from "./solicitation";
import { useReactToPrint } from "react-to-print";
import { Logo } from "components/image/logo";
import { SolicitationPix } from "./solicitation-pix";
import { SolicitationSchedulePix } from "./solicitation-schedule-pix";
import _, { get, set } from "lodash";
import moment from "moment";

import SolicitationInvoiceScreen from "./solicitation-invoice-screen";
import { ManagerType, managerCheck } from "utils/managers";
import { translate } from "config/language";
import { SOLICITATION_STATUS, SOLICITATION_TYPE, isOperatorType } from "utils/static-data";
import {
  businessName,
  businessDocument,
  businessAddress,
  businessAddressLine2,
  businessContact,
} from "config/business";

const { Footer, Content } = Layout;
const { Text } = Typography;

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
  balance: state.balanceReducer,
});

const DataFetch = {
  data: [],
  filtered: null,
  loading: false,
  readStatus: false,
};

const cardStyle = {
  minHeight: '130px',
  textAlign: 'center'
}

const TableCompact = (props) => {
  const [selectByDate, setSelectByDate] = React.useState(false);
  const [date, setDate] = React.useState([]);
  const [pageParams, setPageParams] = useSearchParams();
  const [page, setPage] = React.useState(pageParams.get("page") ?? 1);
  React.useEffect(() => {
    setPageParams((p) => {
      p.set("page", page);
      return p;
    });
  }, [page]);
  const {
    data,
    selectedRowKeys,
    setSelectedRowKeys,
    setData,
    login,
    onChangeBill,
    setInvoice,
    navigate,
    onReport,
    loadingPayment,
    load,
    setRequestId,
    onPaySchedule,
    onReloadBalance,
    cancelShow,
    setCancelShow,
    approvePaymentShow,
    setApprovePaymentShow,
    onCancel,
    onExecutePayment,
    cancelLoading,
    approveLoading,
  } = props;

  const dataSource = data.filtered ? data.filtered : data.data;

  const onSelectAll = () => {
    setSelectedRowKeys(dataSource.map((x) => x.id));
  };

  const onSelectByDate = () => {
    if (date && date.length > 0) {
      setSelectedRowKeys(
        dataSource
          .filter((x) => moment(x.createdAt).isBetween(date[0], date[1]))
          .map((x) => x.id),
      );
    } else {
      setSelectedRowKeys([]);
    }
    setSelectByDate(false);
  };

  const getNameDescription = (name, description) => {
    if (name && description) {
      return `${name} - ${description}`
    } else {
      return name
    }
  }

  const getPaymentName = (statusCode) => {
    switch (statusCode) {
      case SOLICITATION_STATUS.PENDING.code:
          return "PIX";
      case SOLICITATION_STATUS.PENDING_SCHEDULED.code:
          return "Boleto\"Pix\"";
      default:
          return "PIX/Boleto";
    }
  }

  return (
    <React.Fragment>
      <Table
        onChange={(page) => {
          setPage(page.current);
        }}
        rowKey={"id"}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: setSelectedRowKeys,
        }}
        scroll={{ y: 450 }}
        dataSource={dataSource}
        loading={data.loading}
        pagination={{ current: page }}
        bordered
        title={() => (
          <Row align={"middle"}>
            <Col xl={16} lg={12} xs={24}>
              <Space wrap>
                <Button size="small" type={"primary"} onClick={onSelectAll}>
                  Selecionar todos
                </Button>
                <Button
                  size="small"
                  type={"primary"}
                  onClick={() => setSelectByDate(true)}
                >
                  Selecionar por data
                </Button>
                <Typography.Text>
                    Selecionados: {selectedRowKeys.length}/{dataSource.length}
                </Typography.Text>
                <Button
                  size="small"
                  type={"primary"}
                  onClick={() => setSelectedRowKeys([])}
                >
                  Limpar Todos
                </Button>
              </Space>
            </Col>
            <Col xl={8} lg={12} xs={24} className="search-col">
              <TableSearch
                onlyInput
                request={login.company.master ? load : null}
                data={data.data}
                filter={[["company", "name"], "value", "netValue", "id"]}
                onSearch={(e, filtered) => {
                  setData((prev) => ({
                    ...prev,
                    filtered: filtered ? e : null,
                  }));
                }}
              />
            </Col>
          </Row>
        )}
      >
        <Table.Column
          width={180}
          align={"center"}
          title="Data"
          dataIndex="createdAt"
          key="createdAt"
          render={(value) => <FormatDate value={value} />}
        />
        {login.company.master && <Table.Column
          width={300}
          title="Empresa"
          dataIndex={["company"]}
          key="company"
          render={(value) => (
            <Tooltip
              placement="bottom"
              title={
                <Space direction="vertical">
                  {value.corporateName}
                  {value.cnpj}
                </Space>
              }
            >
              {value.name}
            </Tooltip>
          )}
        />}
        {/* <Table.Column
          width={300}
          title="Nome e descrição"
          key="name"
          render={(value) => (
            <Tooltip
              placement="bottom"
              title={
                <Space direction="vertical">
                  {getNameDescription(value.name, value.description)}
                </Space>
              }
            >
              {(value.name || value.description) && <>{getNameDescription(value.name, value.description)}</>}
            </Tooltip>
          )}
        /> */}
        <Table.Column
          width={130}
          align={"center"}
          title="Tipo"
          dataIndex={["type", "name"]}
          key="type.name"
          filters={_.uniqWith(
            (data.filtered ? data.filtered : data.data).map((d) => {
              return { text: d.type.name, value: d.type.code };
            }),
            _.isEqual,
          )}
          onFilter={(value, record) => record.type.code === value}
        />
        <Table.Column
          width={150}
          align={"right"}
          title="Valor do Pedido"
          dataIndex="value"
          key="value"
          render={(value) => <FormatMoney value={value} />}
        />
        <Table.Column
          width={150}
          align={"right"}
          title="Valor a Pagar"
          dataIndex="netValue"
          key="netValue"
          filters={[
            { text: "Com valor a pagar", value: 1 },
            { text: "Sem valor a pagar", value: 0 },
          ]}
          onFilter={(value, record) =>
            value ? record.netValue > 0 : record.netValue === 0
          }
          render={(value) => <FormatMoney value={value} />}
        />
        <Table.Column
          width={270}
          align="center"
          title="Status"
          dataIndex="status"
          key="status"
          filters={_.uniqWith(
            (data.filtered ? data.filtered : data.data).map((d) => {
              return { text: d.status.name, value: d.status.code };
            }),
            _.isEqual
          )}
          onFilter={(value, record) => record.status.code === value}
          render={(status) => {
            if (!status) return <LoadingText loading={true} />;
            const isLoading =
              (typeof status === "string" && status === "loading") ||
              (status && status.code === "loading");
            if (isLoading) return <LoadingText loading={true} />;
            const name = typeof status === "string" ? status : status?.name;
            return <Tag color={status?.category}>{String(name ?? "").toUpperCase()}</Tag>;
          }}
        />
        <Table.Column
          width={180}
          align={"center"}
          title="Data de Pagamento"
          dataIndex="payment"
          key="payment"
          render={(value) => {
            if (value === null) return null;
            if (value.paidAt) return <FormatDate value={value.paidAt} />;
            else
              return (
                <Tooltip placement="bottom" title="Pagamento para o dia...">
                  <Text mark>
                    <FormatDate value={value.paymentAt} />
                  </Text>
                </Tooltip>
              );
          }}
        />
        <Table.Column
          width={180}
          align={"center"}
          title="Data de Aprovação"
          dataIndex="approval"
          key="approval"
          render={(value) => {
            if (value === null) return null;
            if (value.approvedAt)
              return <FormatDate value={value.approvedAt} />;
            else
              return (
                <Tooltip placement="bottom" title="Apenas aprovar no dia...">
                  <Text mark>
                    <FormatDate value={value.approvalAt} />
                  </Text>
                </Tooltip>
              );
          }}
        />
        {(login.company.benefitAccount || login.company.master) && (
          <Table.Column
            width={150}
            align={"center"}
            title={translate("balance")}
            dataIndex={["benefit", "name"]}
            key="benefit.name"
            render={(value) => (value ? value : "Geral")}
          />
        )}
        <Table.Column
          width={login.company.master ? 490 : 380}
          align="center"
          title="Ações"
          dataIndex="id"
          key="id"
          fixed="right"
          filters={
            login.company.master
              ? [
                {
                  text: "Nota Fiscal",
                  value: true,
                },
              ]
              : null
          }
          onFilter={(value, record) => record.actions.taxInvoice === value}
          render={(value, row) => (
            <React.Fragment>
              {((row.type.code === "T" && row.status?.code === "D") || (row.type.code === "S" && row.status?.code === "Q")) && (
                <Button
                  disabled={!row.actions.bill || loadingPayment}
                  size="small"
                  type={"link"}
                  onClick={() => {
                    onChangeBill(value, row, row.status?.code === "D" ? "PIX" : "PIX/Boleto");
                  }}
                >
                  {getPaymentName(row.status?.code)}
                </Button>
              )}
              {/* {((row.type.code === "S" && row.status?.code === "Q")) && (
                <Button
                  disabled={!row.actions.bill || loadingPayment}
                  size="small"
                  type={"link"}
                  onClick={() => {
                    onPaySchedule(row.id);
                  }}
                >
                  Pagar c/ saldo em conta
                </Button>
              )} */}
              {/* <Button
                disabled={!row.actions.bill || loadingPayment}
                size="small"
                type={"link"}
                onClick={() => {
                  onChangeBill(value, row);
                }}
              >
                Boleto
              </Button> */}
              <Button
                size="small"
                type={"link"}
                disabled={!row.actions.invoice}
                onClick={() => {
                  setInvoice({ visible: true, solicitation: value });
                }}
              >
                Nota de Débito
              </Button>
              {row.actions.taxInvoice && (
                <Button
                  disabled={!row.invoiceUrl}
                  size="small"
                  type={"link"}
                  onClick={() => window.open(row.invoiceUrl, "_blank")}
                >
                  Nota Fiscal
                </Button>
              )}
              {login.company.master && (
                <Button
                  size="small"
                  type={"link"}
                  onClick={() => navigate(`/solicitation/${value}`)}
                >
                  Editar
                </Button>
              )}
              <Button
                size="small"
                type={"link"}
                onClick={() => onReport(value)}
              >
                Detalhes
              </Button>
              {(row.type.code === "S" && (row.status?.code === 'S')) &&
                <Fragment>
                  <br />
                  <Button
                    size="small"
                    type={"link"}
                    onClick={() => {
                      setApprovePaymentShow({ show: true, value: row });
                    }}
                  >
                    Antecipar Pgto.
                  </Button>
                  <Button
                    size="small"
                    type={"link"}
                    onClick={() => {
                      setCancelShow({ show: true, value: row });
                    }}
                  >
                    Cancelar
                  </Button>
                </Fragment>
              }
            </React.Fragment>
          )}
        />
      </Table>
      <Modal
        open={selectByDate}
        title="Selecionar pedidos por data"
        onCancel={() => setSelectByDate(false)}
        onOk={onSelectByDate}
      >
        <DatePicker.RangePicker
          style={{ width: "100%" }}
          value={date}
          onChange={(e) => setDate(e)}
        />
      </Modal>
      <Modal
        open={cancelShow.show}
        title="Cancelamento de pedido"
        onOk={onCancel}
        onCancel={() => setCancelShow({ show: false, value: null })}
        confirmLoading={cancelLoading}
      >
        <Text>Confirma o cancelamento desse pedido?</Text>
      </Modal>
      <Modal
        open={approvePaymentShow.show}
        title="Executar pedido"
        onOk={onExecutePayment}
        onCancel={() => setApprovePaymentShow({ show: false, value: null })}
        confirmLoading={approveLoading}
      >
        <Text>Deseja antecipar o pagamento do agendamento para hoje/agora?</Text>
      </Modal>
    </React.Fragment>
  );
};

const SolicitationScreen = (props) => {
  const { login, compact = false, type = "", balance } = props;
  const navigate = useNavigate();
  const [data, setData] = React.useState(DataFetch);
  const [approvingAll, setApprovingAll] = React.useState(false);
  const [invoice, setInvoice] = React.useState({
    visible: false,
    solicitation: null,
  });
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [loadingInvoice, setLoadingInvoice] = React.useState(false);
  const [loadingPayment, setLoadingPayment] = React.useState(false);
  const [fatura, setFatura] = React.useState(null);
  const [printShow, setPrintShow] = React.useState(false);
  const [showPix, setShowPix] = React.useState({ open: false, qrcode: null });
  const [showSchedulePix, setShowSchedulePix] = React.useState({ open: false, qrcode: null });
  const [showPaySchedule, setShowPaySchedule] = React.useState({ open: false, solicitation: null });
  const componentRef = React.useRef();
  const currentRequestId = React.useRef(0);
  const [reloadBalance, setReloadBalance] = React.useState(false);
  const [creditDisabled, setCreditDisabled] = React.useState(true);
  const [cancelShow, setCancelShow] = React.useState({ show: false, value: null });
  const [approvePaymentShow, setApprovePaymentShow] = React.useState({ show: false, value: null });
  const [cancelLoading, setCancelLoading] = React.useState(false);
  const [approveLoading, setApproveLoading] = React.useState(false);
  const { refresh: refreshShareholderStatus } = useShareholderStatus();

  const load = async (filter = null) => {
    setSelectedRowKeys([]);
    currentRequestId.current += 1;
    setData((x) => ({ ...x, loading: true }));

    const [res, shareholderStatus] = await Promise.all([
        getAllSolicitation(filter),
        refreshShareholderStatus(login.company.id),
    ]);

    const mapped = res.map(solicitation => {
        if (solicitation.type.code === SOLICITATION_TYPE.SCHEDULE.code && solicitation.status.code !== SOLICITATION_STATUS.PENDING_SCHEDULED.code) {
            solicitation.netValue = 0;
        }
        return solicitation;
    });

    setData({ data: mapped, loading: false, readStatus: true, filtered: null });
    setCreditDisabled(shareholderStatus.allowCompany ? false : shareholderStatus.hasIssues);
} ;

  const onCancel = async () => {
    setCancelLoading(true);
    await cancelSolicitation(cancelShow.value.id);
    setCancelShow({ show: false, value: null });
    setCancelLoading(false);
    await load();
    onReloadBalance();
  };

  const onExecutePayment = async () => {
    setApproveLoading(true);
    await approveSolicitation(approvePaymentShow.value.id);
    setApprovePaymentShow({ show: false, value: null });
    setApproveLoading(false);
    await load();
    onReloadBalance();
  };

  const onCredit = () => {
    redirectPage("/solicitation/credit", "credit")
  }

  const onReport = (id) => {
    navigate(`/solicitation/${id}/report`);
  };

  const redirectPage = (url, type = "benefit") => {
    if (balance.company.subBalances.length == 0) {
      navigate(url, { state: { benefit: null } });
    }
    else if (balance.company.subBalances.length == 1) {
      navigate(url, { state: { benefit: balance.company.subBalances[0].benefit } });
    } else {
      navigate("/solicitation/balance", { state: { url: url, type } });
    }
  }

  const onApproveSolicitation = async () => {
    setApprovingAll(true);
    await approveSolicitations();
    await load();
    setApprovingAll(false);
  };

  const loadingStatus = async () => {
    const requestId = currentRequestId.current;
    for (let item of data.data
      .filter((d) => d.type.code === "C" && d.status.onRequest)
      .slice(0, 15)) {
      item.status = "loading";
      setData((prev) => ({
        ...prev,
        data: data.data,
        loading: false,
        readStatus: false,
      }));

      let solicitation = await getValidationSolicitation(item.id);
      if (solicitation) {
        item.status = solicitation.status;
      } else {
        item.status = {
          name: "Erro",
          category: "error",
        };
      }
      if (currentRequestId.current !== requestId) break;
      setData((prev) => ({
        ...prev,
        data: data.data,
        loading: false,
        readStatus: false,
      }));
    }
  };

  const onConsolidatedReport = async () => {
    try {
      if (selectedRowKeys.length) {
        setLoading(true);
        const solicitations = data.data.filter((solicitation) => selectedRowKeys.indexOf(solicitation.id) >= 0);
        await consolidatedReport(solicitations);
        setSelectedRowKeys([]);
      } else {
        notification.warning({ message: "Selecione pelo menos um pedido." });
      }
    } finally {
      setLoading(false);
    }
  };

  const onChangeBill = async (solicitation, row, type = "BANK") => {
    try {
      setLoadingPayment(true);
      if (type === "PIX" || type === "PIX/Boleto") {
        let pixQRCode = null;
        if (row.pixQRCode) {
          pixQRCode = row.pixQRCode;
          type === "PIX" ? setShowPix({ open: true, qrcode: pixQRCode }) : setShowSchedulePix({ open: true, qrcode: pixQRCode, solicitation: row });
        } else {
          await getPixQRCode(solicitation)
            .then((_solicitation) => {
              if (_solicitation) {
                pixQRCode = _solicitation.pixQRCode;
                load();
                type === "PIX" ? setShowPix({ open: true, qrcode: pixQRCode }) : setShowSchedulePix({ open: true, qrcode: pixQRCode, solicitation: _solicitation });
              }
            });
        }
      } else {
        let bankSlipUrl = null;
        if (row.bankSlipUrl) {
          bankSlipUrl = row.bankSlipUrl;
        } else {
          await getBankSplit(solicitation)
            .then((_solicitation) => {
              if (_solicitation) {
                bankSlipUrl = _solicitation.bankSlipUrl;
                load();
              }
            });
        }
        if (bankSlipUrl) await downloadBankSlip(bankSlipUrl);
      }

    } finally {
      setLoadingPayment(false);
    }
  };

  const onPaySchedule = async (solicitation) => {
    await setShowPaySchedule({ open: true, solicitation });
  };

  const onReloadBalance = async () => {
    setReloadBalance(prev => !prev);
  }

  const paySchedule = async () => {
    try {
      setLoadingPayment(true);
      if(!showPaySchedule.solicitation) {
        notification.warning({ message: "Pedido inválido!" });
        setLoadingPayment(false);
        return
      }
      await getPaySchedule(showPaySchedule.solicitation);
      load();
      setShowPaySchedule({ open: false, solicitation: null });
    } finally {
      setLoadingPayment(false);
    }
  }

  const onInvoiceTransaction = async () => {
    setLoadingInvoice(true);
    const res = await getInvoiceTransactions(moment().format("YYYY-MM-DD"));
    if (res.url) {
      window.open(res.url);
    } else {
      setFatura(res);
      setPrintShow(true);
    }
    setLoadingInvoice(false);
  };

  const handlePrint = useReactToPrint({
    bodyClass: "print-body",
    copyStyles: false,
    onAfterPrint: () => {
      setPrintShow(false);
    },
    content: () => componentRef.current,
  });

  React.useEffect(() => {
    load();
  }, []);

  React.useEffect(() => {
    if (data.readStatus) {
      loadingStatus();
    }
  }, [data]);

  if (compact) {
    return (
      <TableCompact
        data={data}
        setSelectedRowKeys={setSelectedRowKeys}
        selectedRowKeys={selectedRowKeys}
        setData={setData}
        login={login}
        onChangeBill={onChangeBill}
        setInvoice={setInvoice}
        navigate={navigate}
        onReport={onReport}
        loadingPayment={loadingPayment}
        load={load}
        onPaySchedule={onPaySchedule}
        onReloadBalance={onReloadBalance}
        cancelShow={cancelShow}
        setCancelShow={setCancelShow}
        approvePaymentShow={approvePaymentShow}
        setApprovePaymentShow={setApprovePaymentShow}
        onCancel={onCancel}
        onExecutePayment={onExecutePayment}
        cancelLoading={cancelLoading}
        approveLoading={approveLoading}
      />
    );
  } else {
    const isMasterOperator = login.company?.master && isOperatorType(login.user.userType);
    return (
      <Layout className="alymente-layout">
        <Header
          title="Pedidos"
          routes={
            // login.company.master
            //   ? [
            //       {
            //         label: translate("statement"),
            //         route: "/company/statement",
            //       },
            //       { label: "Tesouraria", route: "/solicitation/treasury" },
            //     ]
            //   :
            []
          }
        >
      {
         !isMasterOperator && (
          <Row gutter={12}>
            <Col xxl={5} xl={8} lg={12}>
              <CardCompanyBalance
                reload={reloadBalance}
                style={cardStyle}
                type={"balance"} />
            </Col>
            <Col xxl={5} xl={8} lg={12}>
              <CardCompanyBalance
                reload={reloadBalance}
                goTo={() => { navigate("/solicitation/incomes") }}
                goToInfo={'Ir para Pedidos pendentes de Cadastro'}
                style={cardStyle}
                type={"charge"} />
            </Col>
            <Col xxl={5} xl={8} lg={12}>
              <CardCompanyBalance
                reload={reloadBalance}
                //goTo={() => { navigate("/solicitation/incomes") }}
                goToInfo={'Ir para Pedidos agendados'}
                style={cardStyle}
                type={"scheduled"} />
            </Col>
            {/* <Col xxl={5} xl={8} lg={12}>
              <CardCompanyBalance
              style={ cardStyle }
              type={"discount"} />
            </Col> */}
          </Row>
        )


      }
        </Header>
        <Content>
          <TableCompact
            data={data}
            setSelectedRowKeys={setSelectedRowKeys}
            selectedRowKeys={selectedRowKeys}
            setData={setData}
            login={login}
            onChangeBill={onChangeBill}
            setInvoice={setInvoice}
            navigate={navigate}
            onReport={onReport}
            loadingPayment={loadingPayment}
            load={load}
            onPaySchedule={onPaySchedule}
            onReloadBalance={onReloadBalance}
            cancelShow={cancelShow}
            setCancelShow={setCancelShow}
            approvePaymentShow={approvePaymentShow}
            setApprovePaymentShow={setApprovePaymentShow}
            onCancel={onCancel}
            onExecutePayment={onExecutePayment}
            cancelLoading={cancelLoading}
            approveLoading={approveLoading}
          />
          <SolicitationPix
            open={showPix.open}
            pixQRCode={showPix.qrcode}
            onClose={() => setShowPix({ open: false, qrcode: null })}
          />
          <SolicitationSchedulePix
            open={showSchedulePix.open}
            pixQRCode={showSchedulePix.qrcode}
            solicitation={showSchedulePix.solicitation}
            onClose={() => setShowSchedulePix({ open: false, qrcode: null, solicitation: null })}
          />
        </Content>
        <Footer>
          <Space>
            <Button
              loading={loading}
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={onConsolidatedReport}
            >
              Relatório Consolidado
            </Button>
            {login.company.companyType.code === "C" && (
              <Fragment>
                {/* {!login.company.master && login.user.admin && (
                  <Button
                    loading={loadingInvoice}
                    type="primary"
                    icon={<FileExcelOutlined />}
                    onClick={onInvoiceTransaction}
                  >
                    Fatura
                  </Button>
                )} */}
                {!login.company.master &&
                  managerCheck(login.user, [
                    ManagerType.BENEFIT,
                    ManagerType.TEAM,
                  ]) && (
                    <>
                      <Tooltip title="Insira crédito na conta da empresa">
                        <Button
                          type="primary"
                          disabled={creditDisabled}
                          icon={<PlusOutlined />}
                          onClick={() => {
                            onCredit();
                          }}
                        >
                          Crédito para Empresa
                        </Button>
                      </Tooltip>
                      {login.company.corporateCard ? (
                        <Dropdown
                          disabled={creditDisabled}
                          menu={{
                            items: [
                              {
                                key: 'incentive',
                                label: 'Crédito para Participante',
                                title: !creditDisabled ? "Insira crédito na conta dos participantes" : "Para inserir crédito na conta de participantes a empresa deve estar válida.",
                                onClick: () => redirectPage("/solicitation/charge/incentive/save"),
                              },
                              {
                                key: 'corporate',
                                label: 'Crédito para Gastos Corporativos',
                                title: !creditDisabled ? "Insira crédito corporativo na conta dos participantes" : "Para inserir crédito na conta de participantes a empresa deve estar válida.",
                                onClick: () => redirectPage("/solicitation/corporate/save"),
                              },
                            ],
                          }}
                        >
                          <Button
                            type="primary"
                            disabled={creditDisabled}
                            icon={<UserAddOutlined />}
                          >
                            Crédito para Participantes
                          </Button>
                        </Dropdown>
                      ) : (
                        <Tooltip title={!creditDisabled ? "Insira crédito na conta dos participantes" : "Para inserir crédito na conta de participantes a empresa deve estar válida."}>
                          <Button
                            type="primary"
                            disabled={creditDisabled}
                            icon={<UserAddOutlined />}
                            onClick={() => redirectPage("/solicitation/charge/incentive/save")}
                          >
                            Crédito para Participante
                          </Button>
                        </Tooltip>
                      )}
                    </>
                  )}
              </Fragment>
            )}
            {
              //   login.company.companyType.code === "M" && (
              //   <Button
              //     loading={approvingAll}
              //     type="primary"
              //     icon={<FileDoneOutlined />}
              //     onClick={onApproveSolicitation}
              //   >
              //     Aprovar Pedidos Pagos
              //   </Button>
              // )
            }
          </Space>
        </Footer>
        <Modal
          open={showPaySchedule.open}
          title="Executar pedido"
          onOk={paySchedule}
          onCancel={() => setShowPaySchedule({ open: false, solicitation: null })}
          confirmLoading={loadingPayment}
        >
          <Text>Confirma o pagamento deste agendamento?</Text>
        </Modal>
        <SolicitationInvoiceScreen
          solicitation={invoice.solicitation}
          visible={invoice.visible}
          onHide={() => setInvoice({ visible: false, solicitation: null })}
        />
        <Modal
          width={1000}
          open={printShow}
          title="Fatura"
          onCancel={() => setPrintShow(false)}
          footer={[
            <Button
              key="submit"
              type="primary"
              loading={false}
              onClick={handlePrint}
            >
              Imprimir
            </Button>,
          ]}
        >
          {fatura != null && (
            <div ref={componentRef} className="print">
              <div className="print-content">
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td align="center">
                        <Typography.Title level={3}>
                          {`${fatura.label}`}
                        </Typography.Title>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <div>
                          <Typography.Text className="green">
                            {businessName()}.
                          </Typography.Text>
                        </div>
                        <div>
                          <Typography.Text className="green">
                            CNPJ {businessDocument()}
                          </Typography.Text>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td height={50}></td>
                    </tr>
                  </tbody>
                </table>
                <table style={{ width: "100%" }}>
                  <tbody>
                    {Object.keys(fatura.details).map((k) => (
                      <tr>
                        <td align="left" width={300}>
                          <Typography.Text level={2} style={{ marginTop: 50 }}>
                            {k}
                          </Typography.Text>
                        </td>
                        <td align="left">
                          <Typography.Text level={2} style={{ marginTop: 50 }}>
                            {fatura.details[k]}
                          </Typography.Text>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {fatura.transactions.length > 0 && (
                  <div className="table-detail" style={{ marginTop: 25 }}>
                    <table style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          {Object.keys(fatura.transactions[0]).map((k) => (
                            <th style={{ textAlign: "left" }}>
                              <Typography.Text strong className="white">
                                {k}
                              </Typography.Text>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {fatura.transactions.map((t) => {
                          return (
                            <tr>
                              {Object.keys(t).map((k) => (
                                <td>
                                  <Typography.Text className="black">
                                    {t[k]}
                                  </Typography.Text>
                                </td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="print-footer">
                  <div className="print-logo">
                    <Logo justify="flex-start" />
                  </div>
                  <div className="alymente">
                    <Typography.Text className="black" strong>
                      {businessName()}
                    </Typography.Text>
                    <Typography.Text className="black">
                      <strong>CNPJ:</strong> {businessDocument()}
                    </Typography.Text>
                    <Typography.Text className="black">
                      {businessAddress()}
                    </Typography.Text>
                    <Typography.Text className="black">
                      {businessAddressLine2()}
                    </Typography.Text>
                    <Typography.Text className="black">
                      {businessContact()}
                    </Typography.Text>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Layout>
    );
  }
};

export default connect(mapStateToProps, {})(SolicitationScreen);
